import { PermissionsEnum } from "@/auth/interfaces";
import { SaveOrdenesCompra } from "../../shared/saveOrdenesCompra";
import { useCheckPermissions } from "@/shared";
export interface CreateOrdenesComprasPageInterface {}

const CreateOrdenesComprasPage: React.FC<CreateOrdenesComprasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ordencompra)

  return <SaveOrdenesCompra titlePage="Crear Orden de Pedido" />;
};

export default CreateOrdenesComprasPage;
